export class ComplainTitleModel {
    public titleId:number;		
    public  titleName:string;
    public  typeId:number;		
    public  typeName:string;
    public  subTypeId:number;		
    public  subTypeName:string;     
 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/complainTitle/complainTitle.model.ts